export default __webpack_public_path__ + "static/media/detail_small_5_4.3a7cc5e2.png";